import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Subscriptions {
  'search emails group': boolean;
  'all emails group': boolean;
  'booking group': boolean;
  'conversation group': boolean;
  'marketing group': boolean;
}

export default (makeCall: MakeCall) =>
  (userId: number, subscriptions: Subscriptions) =>
    makeCall<Subscriptions>(
      'PUT',
      `${APIV2_URL}/user/${userId}/subscriptions`,
      {
        data: subscriptions,
      },
    );
